/**
 * ============================================================
 * sortPublications.js — sorts publications for display
 * ============================================================
 *
 * This utility does the following:
 * - Groups pubs by year
 * - Sorts years in descending order
 * - Sorts pubs alphabetically by title within year year
 * - Returns { years, yeargroups, flattened }
 **/

export function sortPubsByYearAndTitle(publications) {
  if (!Array.isArray(publications)) return {
    years: [],
    yeargroups: {},
    flattened: []
  };

  // ------------------------------------------------------------
  // Group by year
  // ------------------------------------------------------------
  const yeargroups = {};
  for (const pub of publications) {
    const y = pub.year || 0;
    if (!yeargroups[y]) yeargroups[y] = [];
    yeargroups[y].push(pub);
  }

  // ------------------------------------------------------------
  // Sorted list of valid years
  // ------------------------------------------------------------
  const years = Object.keys(yeargroups)
    .map(Number)
    .filter((y) => y !== 0)
    .sort((a, b) => b - a);

  // ------------------------------------------------------------
  // Sort alphabetical inside each year
  // ------------------------------------------------------------
  years.forEach((year) => {
    yeargroups[year].sort((a, b) =>
      (a.title || "").localeCompare(b.title || "", undefined, {
        sensitivity: "base",
      })
    );
  });

  // ------------------------------------------------------------
  // Flatten all in sorted order
  // ------------------------------------------------------------
  const flattened = [];
  years.forEach((year) => {
    yeargroups[year].forEach((pub) => flattened.push(pub));
  });

  return { years, yeargroups, flattened };
}
